import { type DocumentNode, gql } from '@apollo/client';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import type { FieldValue, OAuth2LoginArgs } from './types';

interface GetAuthURLQueryResult {
  query: {
    oauth2AuthUrl: {
      __args: {
        callbackUrl: string;
      };
    };
  };
}

interface OAuth2LoginMutationResult {
  mutation: {
    oauth2Login: {
      __args: OAuth2LoginArgs;
      success: FieldValue;
      token: FieldValue;
      refreshExpiresIn: FieldValue;
      payload: FieldValue;
    };
  };
}

export const getAuthURL = (callbackUrl: string): GetAuthURLQueryResult => ({
  query: {
    oauth2AuthUrl: {
      __args: {
        callbackUrl,
      },
    },
  },
});

export const oauth2login = (truify: boolean = false, __args: OAuth2LoginArgs): OAuth2LoginMutationResult => ({
  mutation: {
    oauth2Login: {
      __args,
      success: truify,
      token: truify,
      refreshExpiresIn: truify,
      payload: truify,
    },
  },
});

export const buildGetAuthURL = (callbackUrl: string): DocumentNode => {
  const q = getAuthURL(callbackUrl);
  const gQuery = jsonToGraphQLQuery(q, { pretty: true });
  return gql(gQuery);
};

export const buildOauth2login = (truify: boolean, { authResponse, callbackUrl }: OAuth2LoginArgs): DocumentNode => {
  const m = oauth2login(truify, { authResponse, callbackUrl });
  const gMutation = jsonToGraphQLQuery(m, { pretty: true });
  return gql(gMutation);
};
